module.exports = __webpack_public_path__ + "static/media/cq_mail.61fdd638.svg";